module.exports = __webpack_public_path__ + "img/RMSUYSolutionsLogoIcon.c145492f.jpg";